import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_TinyMCE = _resolveComponent("TinyMCE")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorSubtitle'
		],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Internal Notes ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorText'
		],
      isLoading: _ctx.isLoading,
      tag: "p"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" Use this section to document any important details or specific notes about the campaign. These notes are for internal use only and will not be visible to clients. ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'LargeLoadingContent'
		],
      isLoading: _ctx.isLoading || _ctx.isLazyLoading,
      tag: "div"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TinyMCE, { "initial-value": _ctx.internalNotes }, null, 8 /* PROPS */, ["initial-value"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"])
  ], 64 /* STABLE_FRAGMENT */))
}